export const MANUAL_VERIFICATIONS_TASKS_GENERATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingDocument.ManualVerification.ManualVerificationsTasksGenerated";

export const OFFER_ENTITIES_INVALIDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.OfferEntitiesInvalidated";
